export default function () {
  this.id = null;
  this.IdEvento = null;
  this.IdIscritto = null;
  this.StatoIscrizione = null;
  this.isAttivo = null;
  this.isPostoRiservato = null;
  this.isPresente = null;
  this.DataPrenotazione = null;
  this.DataIscrizione = null;
  this.DataPagamento = null;
  this.Categoria = null;
  this.Note = null;
  this.UserPrenotazione = null;
  this.UserIscrizione = null;
  this.confirmed = null;
}
